module.exports = __webpack_public_path__ + "media/public/fonts/QanelasLight/QanelasLight-2b1e0deb2e601a4ffd0c71ab7b9b3142.ttf";